<script lang="ts">
  import Button from "src/partials/Button.svelte"
</script>

<div class="z-10 relative -mt-4 mb-0 flex justify-center">
  <Button stopPropagation class="btn btn-low" on:click>See more</Button>
</div>
